<template>
  <el-container>
    <el-main style="height:100vh;padding:0px">
      <div  class="div-form">
      <el-form :label-position="labelPosition" :model="formappversion" :rules="rules" label-width="80px"  size="mini"  ref="formappversion">
<!--        <el-form-item label="产品名称"  prop ="productName">-->
<!--          <el-col :span="10">-->
<!--          <el-input v-model="formappversion.productName" ></el-input>-->
<!--          </el-col>-->
<!--        </el-form-item>-->

        <el-form-item label="产品名称"  prop="productName">
          <el-col :span="10">
            <el-select v-model="formappversion.productName"   style="width:100%" @change="changeproduct" placeholder="请选择产品">
              <el-option
                v-for="item in productNames"
                :key="item.label"
                :label="item.label"
                :value="item.label">
              </el-option>
            </el-select>
          </el-col>
        </el-form-item>

        <el-form-item label="技术描述"  prop ="techDesc">
          <el-col :span="10">
          <el-input v-model="formappversion.techDesc" ></el-input>
          </el-col>
        </el-form-item>
        <el-form-item label="发布时间"  prop="publishDate">
          <el-col :span="10">
            <el-date-picker type="date" placeholder="选择日期" v-model="formappversion.publishDate" style="width: 100%;" format="yyyy-MM-dd HH:mm:ss" value-format="yyyy-MM-dd HH:mm:ss"></el-date-picker>
          </el-col>
          <el-col class="line" :span="2">-</el-col>
        </el-form-item>
        <el-form-item label="版本号"  prop ="version">
          <el-col :span="10">
            <el-input v-model="formappversion.version" ></el-input>
          </el-col>
        </el-form-item>
        <el-form-item label="内部版本"  prop ="innerVersion">
          <el-col :span="10">
            <el-input v-model="formappversion.innerVersion" ></el-input>
          </el-col>
        </el-form-item>
        <el-form-item>
          <el-col :span="10">
          <el-button type="primary" @click="save(formappversion)"  >保存</el-button>
          <el-button plain @click="reset">重置</el-button>
          <el-button plain @click="closed">返回</el-button>
          </el-col>
        </el-form-item>
      </el-form>
      </div>
    </el-main>
  </el-container>
</template>

<script>
import axios from '../../../utils/request'

export default {
  data () {
    return {
      formappversion: {
        productName: '',
        techDesc: '',
        publishDate: '',
        version: '',
        innerVersion: '',
        id: 1,
        type: 2
      },
      loading1: false,
      productNames: [{value: 2, label: '光伏清洗'}, {value: 3, label: '消防吊桶'}, {value: 4, label: '无线电检测盒子'}, {value: 5, label: '六段抛投'}, {value: 6, label: '喊话器'}, {value: 7, label: '破窗弹'}, {value: 8, label: '探照灯'}],
      rules: {
        productName: [
          { required: true, message: '请填产品名称', trigger: 'change' }
        ],
        techDesc: [
          { required: true, message: '请填技术描述', trigger: 'change' }
        ],
        publishDate: [
          { required: true, message: '发布日期', trigger: 'change' }
        ],
        version: [
          { required: true, message: '版本', trigger: 'change' }
        ],
        innerVersion: [
          { required: true, message: '内部版本', trigger: 'change' }
        ]
      }
    }
  },
  mounted () {
    this.loading()
  },
  methods: {
    save: function (formUaccount) {
      this.loading = true
      console.log(this.$refs.formappversion)
      console.log(123456)
      this.$refs.formappversion.validate((valid) => {
        if (valid) {
          console.log(valid)
          let query = this.$route.query
          if (query.requesttype === 'update') {
            // this.$delete(params, 'requesttype')
            console.log('update', this.formappversion)
            axios.put('/data/appversion/update', this.formappversion).then(res => {
              console.log('success')
              this.closed()
            })
          } else {
            axios.post('/data/appversion/insert', this.formappversion).then(res => {
              console.log('success')
              this.closed()
            })
          }
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    reset: function () {
      this.formappversion.productName = ''
      this.formappversion.techDesc = ''
      this.formappversion.publishDate = ''
      this.formappversion.version = ''
      this.formappversion.innerVersion = ''
    },
    closed: function () {
      console.log('/data/productversion')
      this.$router.push('/data/productversion')
    },
    loading: function () {
      console.log(123456)
      console.log(this.$route)
      this.formappversion.productName = this.$route.query.productName
      this.formappversion.techDesc = this.$route.query.techDesc
      this.formappversion.publishDate = this.$route.query.publishDate
      this.formappversion.version = this.$route.query.version
      this.formappversion.innerVersion = this.$route.query.innerVersion
      this.formappversion.id = this.$route.query.id
    }
  }
}
</script>

<style scoped>
  .el-container {
    height: 100%;
  }
  .el-main {
    background-color: #E9EEF3;
    color: #333;
    text-align: center;
    line-height: 160px;
  }
  .div-form{
    margin-top: 100px;
    margin-left: 280px;
  }
</style>



// WEBPACK FOOTER //
// src/components/table/productversion/addproductversion.vue